/**
 * Wording shared by the Vendors table and the vendor panel, so a vendor reads
 * the same in both.
 */
export const QUICKBOOKS_VENDOR_LABEL = "QuickBooks vendor";
export const QUICKBOOKS_EXPENSE_ACCOUNT_LABEL = "Expense account";
export const QUICKBOOKS_NOT_LINKED = "Not linked";
export const QUICKBOOKS_BUSINESS_DEFAULT = "Business default";
